module.exports = __webpack_public_path__ + "img/sunFlower-5.e2a282e1.jpg";